<template>
  <div>
    <Navigation />
    <div class="row tableUsers">
      <div v-if="addNewMachine" class="popUp-overlay"></div>
      <div v-if="addNewMachine" class="popUp-dialogScrollable zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="form_name"
                      >Machine Name
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <input
                      v-model="machine_name"
                      id="machine_name"
                      type="text"
                      name="machine_name"
                      class="form-control"
                      v-bind:class="
                        errorMsg && !machine_name ? 'border-red' : 'border-none'
                      "
                      placeholder=""
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="form_name"
                      >IP address
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <input
                      v-model="machine_ip"
                      id="machine_ip"
                      type="text"
                      name="machine_ip"
                      class="form-control"
                      v-bind:class="
                        errorMsg && !machine_ip ? 'border-red' : 'border-none'
                      "
                      placeholder=""
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="form_name"
                      >Location
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <input
                      v-model="location"
                      id="location"
                      type="text"
                      name="location"
                      class="form-control"
                      v-bind:class="
                        errorMsg && !location ? 'border-red' : 'border-none'
                      "
                      placeholder=""
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="form_name">Description</label>
                    <input
                      v-model="description"
                      id="description"
                      type="text"
                      name="description"
                      class="form-control"
                      placeholder=""
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="form_name">Serial Number (RVM machines)</label>
                    <input
                      v-model="serial_number"
                      id="serial_number"
                      type="text"
                      name="description"
                      class="form-control"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="form_name"
                      >Link to Cloud</label
                    >
                    <input
                      v-model="cloudLink"
                      id="cloudLink"
                      type="text"
                      name="cloudLink"
                      class="form-control"
                      placeholder=""
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div v-if="errorMsg" class="row">
                <div class="col-md-12">
                  <div class="error-infobox">
                    {{ errorMsg }}
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="addMachine()"
                    type="submit"
                    class="btn btnDark btn-success btn-send pointer"
                    value="Submit"
                  />
                  <input
                    v-on:click="addNewMachine = false"
                    type="cancel"
                    class="btn btn-secondary pointer button-width-helper"
                    value="Cancel"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="editMachine" class="popUp-overlay"></div>
      <div v-if="editMachine" class="popUp zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="edit_machine_name"
                      >Machine Name
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <input
                      id="edit_machine_name"
                      type="text"
                      name="edit_machine_name"
                      v-model="edit_machine_name"
                      class="form-control"
                      v-bind:class="
                        errorMsg && !edit_machine_name
                          ? 'border-red'
                          : 'border-none'
                      "
                      placeholder=""
                      required="required"
                      data-error="error"
                      value="Machine1"
                    />
                    <input type="hidden" v-model="edit_machine_id" value="" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="edit_machine_ip"
                      >IP address
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <input
                      id="edit_machine_ip"
                      type="text"
                      name="edit_machine_ip"
                      v-model="edit_machine_ip"
                      class="form-control"
                      v-bind:class="
                        errorMsg && !edit_machine_ip
                          ? 'border-red'
                          : 'border-none'
                      "
                      placeholder=""
                      required="required"
                      data-error="error"
                      value="Skopje City Mall"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="edit_location"
                      >Location
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label
                    >
                    <input
                      id="edit_location"
                      type="text"
                      name="edit_location"
                      v-model="edit_location"
                      class="form-control"
                      v-bind:class="
                        errorMsg && !edit_location
                          ? 'border-red'
                          : 'border-none'
                      "
                      placeholder=""
                      required="required"
                      data-error="error"
                      value="66.249.71.196"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="edit_description"
                      >Description</label
                    >
                    <textarea
                      id="edit_description"
                      type="text"
                      name="edit_description"
                      v-model="edit_description"
                      class="form-control"
                      placeholder=""
                      required="required"
                      data-error="error"
                      value="Machine1 description"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="edit_serial"
                      >Serial Number (RVM machines)
                      <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        ></span
                      ></label
                    >
                    <input
                      id="edit_serial"
                      type="text"
                      name="edit_serial"
                      v-model="edit_serial"
                      class="form-control"
                      v-bind:class="
                        errorMsg && !edit_serial
                          ? 'border-red'
                          : 'border-none'
                      "
                      placeholder=""
                      data-error="error"
                      value=""
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="edit_description"
                      >Link to Cloud</label
                    >
                    <textarea
                      id="edit_cloudLink"
                      type="text"
                      name="edit_cloudLink"
                      v-model="edit_cloudLink"
                      class="form-control"
                      placeholder=""
                      required="required"
                      data-error="error"
                      value="Machine1 description"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div v-if="errorMsg" class="row">
                <div class="col-md-12">
                  <div class="error-infobox">
                    {{ errorMsg }}
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="updateMachine()"
                    type="submit"
                    class="btn btnDark btn-success btn-send pointer"
                    value="Submit"
                  />
                  <input
                    v-on:click="
                      editMachine = false;
                      clearFields();
                    "
                    type="cancel"
                    class="btn btn-secondary pointer button-width-helper"
                    value="Cancel"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="deleteMachine" class="popUp-overlay"></div>
      <div v-show="deleteMachine" class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="delete_machine_id"
                      >Are you sure you want to delete this machine?</label
                    >
                    <input
                      type="hidden"
                      v-model="delete_machine_id"
                      name="delete_machine_id"
                      value=""
                    />
                    <label v-if="errorMsg" class="floatLeft error-infobox">
                      {{ errorMsg }}
                    </label>
                    <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="confirmDelete()"
                    type="submit"
                    class="btn danger btnDark btn-success btn-send pointer"
                    value="Yes"
                  />
                  <input
                    v-on:click="deleteMachine = false"
                    type="cancel"
                    class="btn btnDark btn-success pointer"
                    value="No"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4"
            >
              <div class="row">
                <div class="col-sm-12 col-md-4 tableName">
                  <a
                    href="#"
                    class="btn btn-round btn-icon btn-sm createNew mt-1"
                    title="Add new machine"
                    v-on:click="addNew()"
                    ><i class="fas fa-plus"></i>
                  </a>
                  Machines
                </div>
                <div class="col-sm-12 col-md-5"></div>
                <div class="col-sm-12 col-md-3">
                  <div id="datatable_filter" class="dataTables_filter mt-3">
                    <form
                      class="
                        form-inline
                        md-form
                        floatRight
                        searchDiv
                        form-sm
                        active-darkGreen-2
                        mt-2
                      "
                    >
                      <input
                        class="form-control borderNone form-control-sm mr-3"
                        v-model="search"
                        v-on:keyup="filterResults()"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                      />
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 min-table-height">
                  <table
                    id="datatable"
                    class="
                      table table-striped table-bordered
                      dataTable
                      dtr-inline
                    "
                    cellspacing="0"
                    width="100%"
                    role="grid"
                    aria-describedby="datatable_info"
                    style="width: 100%"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-sort="ascending"
                          aria-label="Name: activate to sort column descending"
                          v-on:click="sortResults(1)"
                        >
                          Machine Name
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Office: activate to sort column ascending"
                          v-on:click="sortResults(2)"
                        >
                          Code
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Office: activate to sort column ascending"
                          v-on:click="sortResults(2)"
                        >
                          Location
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Age: activate to sort column ascending"
                        >
                          IP address
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Office: activate to sort column ascending"
                        >
                          Description
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Office: activate to sort column ascending"
                          v-on:click="sortResults(3)"
                        >
                          Last Seen ON
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Office: activate to sort column ascending"
                          v-on:click="sortResults(4)"
                        >
                          Last Recycled ON
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Office: activate to sort column ascending"
                        >
                          Link to Cloud
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Age: activate to sort column ascending"
                        >
                         Serial number
                        </th>
                        <th
                          class="disabled-sorting text-right sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="row"
                        v-bind:key="index"
                        v-for="(item, index) in items"
                        v-bind:class="[
                          index % 2 == 0 || index == 0 ? 'even' : 'odd',
                        ]"
                      >
                        <td tabindex="0" class="sorting_1">{{ item.name }}</td>
                        <td>{{ item.code }}</td>
                        <td>{{ item.location }}</td>
                        <td>{{ item.ip_address }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.last_seen_on }}</td>
                        <td>{{ item.last_recycled_on }}</td>
                        <td v-if="item.cloudLink">
                          <a
                            :href="item.cloudLink"
                            target="_blank"
                            class="textDec"
                            ><i class="fas fa-cloud fa-2x"> </i
                          ></a>
                        </td>
                        <td v-else>
                          <a href="#" class="textDec" v-on:click="edit(item.id)"
                            >Please insert link to cloud services.</a
                          >
                        </td>
                        <td>{{ item.serial_number }}</td>
                        <td class="text-right">
                          <div class="actions_on_user">
                            <a
                              href="#"
                              class="
                                btn btn-round btn-edit btn-icon btn-sm
                                edit
                              "
                              v-on:click="edit(item.id)"
                              id="edit"
                              ><i class="far fa-edit"></i
                            ></a>
                            <label class="activity_label" for="edit"
                              >Edit</label
                            >
                          </div>
                          <div class="actions_on_user">
                            <!-- <a
                              href="#"
                              class="
                                btn btn-round btn-danger btn-icon btn-sm
                                remove
                              "
                              v-on:click="del(item.id)"
                              id="delete"
                              ><i class="fas fa-times"></i
                            ></a>
                            <label class="activity_label" for="delete"
                              >Delete</label
                            > -->
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <pagination :meta_data="meta_data" v-on:next="fetchResults">
              </pagination>
            </div>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Navigation from "@/views/Navigation.vue";
import Pagination from "@/components/Pagination.vue";
import store from "./../store/index";
export default {
  components: {
    Navigation,
    Pagination,
  },
  data() {
    return {
      addNewMachine: false,
      editMachine: false,
      deleteMachine: false,
      machine_name: "",
      machine_ip: "",
      location: "",
      description: "",
      cloudLink: "",
      serial_number: null,
      machine_id: null,
      edit_machine_name: "",
      edit_machine_ip: "",
      edit_location: "",
      edit_description: "",
      edit_cloudLink: "",
      edit_machine_id: null,
      edit_serial: null,
      delete_machine_id: "",
      errorMsg: "",
      items: [],
      search: null,
      order: null,
      sort: null,
      dir: 0,
      id: null,
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
      },
    };
  },
  mounted() {
    this.fetchResults(
      this.meta_data.current_page,
      this.meta_data.perpage,
      this.search,
      this.order,
      this.sort,
      this.meta_data.total
    );
  },
  methods: {
    clearFields() {
      this.edit_machine_name =
        this.edit_machine_id =
        this.edit_description =
        this.edit_machine_ip =
        this.edit_location =
        this.errorMsg =
        this.edit_cloudLink =
          "";
    },
    addNew() {
      this.$data.addNewMachine = true;
      this.errorMsg = "";
      this.machine_name =
        this.machine_ip =
        this.location =
        this.cloudLink =
        this.description =
        this.serial_number =
          null;
    },
    edit(id) {
      this.edit_machine_name =
        this.edit_machine_id =
        this.edit_description =
        this.edit_machine_ip =
        this.edit_location =
        this.errorMsg =
        this.edit_cloudLink =
        this.edit_serial =
          "";
      axios
        .get(store.state.BASE_URI + "admin/machines/fetch_machine", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            id,
          },
        })
        .then((res) => {
          this.edit_machine_name = res.data.machine.name;
          this.edit_machine_id = res.data.machine.id;
          this.edit_description = res.data.machine.description;
          this.edit_location = res.data.machine.location;
          this.edit_machine_ip = res.data.machine.ip_address;
          this.edit_cloudLink = res.data.machine.cloudLink;
          this.edit_serial = res.data.machine.serial_number
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
          }
        });
      this.$data.editMachine = true;
    },

    del(id) {
      this.delete_machine_id = this.errorMsg = "";
      this.delete_machine_id = id;

      this.$data.deleteMachine = true;
    },
    fetchResults(
      page = this.meta_data.current_page,
      perpage = this.meta_data.perpage,
      search = this.search,
      order = this.order,
      sort = this.sort,
      total = this.meta_data.total
    ) {
      axios
        .get(store.state.BASE_URI + "admin/machines/load_machines", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            page,
            perpage,
            search,
            order,
            sort,
            total,
          },
        })
        .then((res) => {
          this.items = res.data.results.items;
          var pagination = res.data.results.pagination;
          this.meta_data.last_page = pagination.last_page;
          this.meta_data.current_page = pagination.current_page;
          this.meta_data.prev_page_url = pagination.prev_page_url;
          this.meta_data.perpage = pagination.perpage;
          this.meta_data.search = pagination.search;
          this.meta_data.total = pagination.total;
        });
    },
    filterResults() {
      this.meta_data.current_page = 1;
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort,
        this.meta_data.total
      );
    },
    sortResults(order) {
      this.dir++;
      this.order = order;

      if (this.dir % 2 == 0) this.sort = "desc";
      else this.sort = "asc";
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort
      );
    },
    addMachine() {
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("accessToken");
      axios
        .post(store.state.BASE_URI + "admin/machines/create", {
          params: {
            name: this.machine_name,
            ip_address: this.machine_ip,
            location: this.location,
            description: this.description,
            cloudLink: this.cloudLink,
            serial_number: this.serial_number
          },
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
        })
        .then((response) => {
          this.fetchResults(
            this.meta_data.current_page,
            this.meta_data.perpage,
            this.search,
            this.order,
            this.sort
          );
          this.addNewMachine = false;
          if (response.data.message) {
            this.$toasted
              .show(response.data.message, {
                type: "success",
              })
              .goAway(2000);
          }
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            if (this.validateFields()) {
              this.$toasted
                .show(this.errorMsg, {
                  type: "success",
                })
                .goAway(2000);
            }
          }
        });
    },
    confirmDelete() {
      axios
        .delete(
          store.state.BASE_URI +
            "admin/machines/machine/" +
            this.delete_machine_id,
          { headers: { Authorization: localStorage.getItem("accessToken") } }
        )
        .then((res) => {
          this.fetchResults(
            this.meta_data.current_page,
            this.meta_data.perpage,
            this.search,
            this.order,
            this.sort
          );
          this.deleteMachine = false;
          this.$toasted
            .show(res.data.message, {
              type: "success",
            })
            .goAway(2000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            this.$toasted.show(this.errorMsg, { type: "error" }).goAway(2000);
          }
        });
    },
    updateMachine() {
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("accessToken");
      axios
        .post(store.state.BASE_URI + "admin/machines/edit", {
          params: {
            id: this.edit_machine_id,
            name: this.edit_machine_name,
            ip_address: this.edit_machine_ip,
            location: this.edit_location,
            description: this.edit_description,
            cloudLink: this.edit_cloudLink,
            serial_number: this.edit_serial
          },
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
        })
        .then((response) => {
          this.editMachine = false;
          this.fetchResults(
            this.meta_data.current_page,
            this.meta_data.perpage,
            this.search,
            this.order,
            this.sort
          );
          this.$toasted
            .show(response.data.message, {
              type: "success",
            })
            .goAway(2000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            if (this.validateFields()) {
              this.$toasted
                .show(this.errorMsg, {
                  type: "success",
                })
                .goAway(2000);
            }
          }
        });
    },
    validateFields() {
      return !this.machine_name || !this.machine_ip || !this.location
        ? false
        : true;
    },
  },
};
</script>

<style src="../css/style.css"></style>
